import PropTypes from 'prop-types';
import React from 'react';

import Page from './sidebar/page';

export default class Sidebar extends React.Component {
  static propTypes = {
    // The current sidebar state for each page.
    pages: PropTypes.arrayOf(PropTypes.shape(Page.propTypes)).isRequired,

    // How often we should trigger refresh: it should be somewhat less than the JWT expiration.
    refreshInSeconds: PropTypes.number.isRequired,
  };

  componentDidMount () {
    this.checkInterval = window.setInterval(
      () => location.reload(),
      this.props.refreshInSeconds * 1000,
    );
  }

  componentWillUnmount () {
    window.clearInterval(this.checkInterval);
  }

  render () {
    return (
      <div className="sidebar">
        <h4 className="sidebar-title">Current status</h4>
        <div>{this.props.pages.map(page => <Page {...page} key={page.id} />)}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/stride/sidebar.jsx